import { Routes, Route, Navigate } from "react-router-dom";

import PageNotFound from "../pages/PageNotFound";
import { RouteConfig, routeConfigList, RouteType } from "./RouteConfigList";
import { AppRouteURL } from "../data/route/AppRouteURL";

const AppRoutes = () => {
  return (
    <Routes>
      {/* <Route path="/" element={<Navigate to={AppRouteURL.HomePage} />} /> */}
      
      {routeConfigList?.map((route:RouteConfig) => {
        const { path, component: Component, wrapper: Wrapper, extraProps = {} } = route;

        if (route.routeType === RouteType.Private) {
          return (
            <Route
              key={path}
              path={path}
              element={
                <Wrapper>
                  <Component {...extraProps} />
                </Wrapper>
              }
            />
          );
        }

        return (
          <Route
            key={path}
            path={path}
            element={
              <Wrapper>
                <Component {...extraProps} />
              </Wrapper>
            }
          />
        );
      })}

      {/* Page Not Found route */}
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default AppRoutes;

